<template>
  <div class="course-center">
    <div class="container">
      <div ref="breadcrumb">
        <sift-breadcrumb></sift-breadcrumb>
      </div>
      <course-select />
      <div class="list-tab clear">
        <div class="list-tab__title">综合排序</div>
        <div class="list-tab__right-bar clear">
          <div class="right-bar__text">
            共 <strong>{{ courseCount }}</strong> 个课程
          </div>
        </div>
      </div>
      <div ref="courseList">
        <div v-if="courseList && courseList.length <= 0" class="no-course">
          <img
            class="no-course__img"
            src="//res11.xesimg.com/x5mall/img/none_record.png"
            alt=""
          />
          <p class="no-course__text">对不起，当前时段暂时没有课程</p>
        </div>
        <div class="courseList" v-else>
          <course-card
            v-for="(item, index) in courseList"
            :key="index"
            :index="index"
            keyName="xeslog-coursecenter-coursecard"
            clickId="1.2.11"
            :termId="termsEnum[item.terms[0].name]"
            :courseType="courseType"
            :data="item"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dealHead from './util/dealHead.js'
import { mapState, mapMutations } from 'vuex'
import Enum from 'cg-enum'
import Cookies from 'js-cookie'
import { Observable } from 'rxjs/Observable'
import 'rxjs/add/observable/fromEvent'
import 'rxjs/add/operator/debounceTime'
import { Course } from '@/networks/api'
import titleMixin from '@/util/title'
import { CourseLocation, termsEnum, siftParams } from '@/defines'
import courseCenterComponents from './components'
// import judgeTokenExp from '@/util/judgeTokenExp'
// import { gradeVerify, courseTypeVerify, subjectVerify } from '@/util/routerValidate'

import types from './store/types'
import headMixin from '@/mixins/head.js'

const listMode = new Enum(['list', 'tab'], 1)
export default {
  name: 'course-center',
  // validate ({ route, gradeEnum, subjectEnum }) {
  //   // 路由参数验证
  //   const { params } = route
  //   return (
  //     courseTypeVerify(params, true) &&
  //     gradeVerify(params, gradeEnum, true) &&
  //     subjectVerify(params, subjectEnum, true)
  //   )
  // },
  mixins: [titleMixin, headMixin],
  head(route) {
    return dealHead(route, this.gradeEnum, this.siftCourseType, this.subjectNameZh)
  },
  asyncData({ store, route }) {
    const { dispatch } = store
    return Promise.all([
      // 课程标准化
      dispatch(types.GET_COURSE_SIFT, { route }),
      dispatch(types.GET_COURSE_LIST, { route })
      // dispatch(types.GET_DIFFICULT_GUIDE, { route })
    ])
  },
  data() {
    return {
      termsEnum,
      listMode,
      mode: null,
      scrollObservable: null,
      scrollLoading: false,
      page: 1,
      showDiffcultRecommend: false
    }
  },
  watch: {
    xAreaID() {
      let userGrade = this.$store.state.cookies.userGrade
        ? this.$store.state.cookies.userGrade
        : 4
      let { grade = userGrade } = this.$route.params
      if (Number(this.xAreaID) === 9 && Number(grade) === 7) {
        return
      }
      if (
        Number(this.xAreaID) !== 9 &&
        Number(this.xAreaID) !== 100 &&
        Number(grade) === 26
      ) {
        return
      }
      const { asyncData } = this.$options
      asyncData({
        store: this.$store,
        route: this.$route
      })
    },
    $route() {
      const list = this.courseList.map(item => {
        return {
          category: item.category,
          id: item.id,
          price: item.price,
          name: item.name,
          subjects: item.subjects,
          syllabusNum: item.syllabusNum
        }
      })
      this.xesLog(
        'exposure',
        { type: 'xeslog-courseCenterList-exposure', content: list },
        { target: this.$refs.courseList }
      )
    }
  },
  beforeRouteUpdate(to, from, next) {
    // 埋个点
    const exgradeid = Number(from.params.grade)
    const gradeid = Number(to.params.grade)
    const excoursetype = Number(from.params.courseType)
    const coursetype = Number(to.params.courseType)
    const exsubjectid = Number(from.params.subject)
    const subjectid = Number(to.params.subject)
    let params = {}
    if (exgradeid !== gradeid) {
      params = {
        clickId: '1.3.56',
        key: 'xeslog-click-breadcrumb-grade',
        exgradeid: exgradeid,
        gradeid: gradeid
      }
    } else if (excoursetype !== coursetype) {
      params = {
        clickId: '1.3.57',
        key: 'xeslog-click-breadcrumb-coursetype',
        excoursetype: excoursetype,
        coursetype: coursetype
      }
    } else if (exsubjectid !== subjectid) {
      params = {
        clickId: '1.3.58',
        key: 'xeslog-click-breadcrumb-subjectid',
        exsubjectid: exsubjectid,
        subjectid: subjectid
      }
    }
    this.xesLog('click', params, { target: this.$refs.breadcrumb })
    this.page = 1
    const {
      query: { isLogin, isLogout, isRegister }
    } = from
    if (isLogin || isLogout || isRegister) {
      next()
      return
    }
    next()
  },
  created() {
    this.mode = this.$store.state.cookies.xes_list_type || listMode.tab
  },
  beforeDestroy() {
    if (this.scrollObservable) this.scrollObservable.unsubscribe()
  },
  mounted() {
    this.scrollObservable = Observable.fromEvent(window, 'scroll')
      .debounceTime(1000 / 60)
      .subscribe(() => {
        this.scrollLoad()
      })
    const list = this.courseList.map(item => {
      return {
        category: item.category,
        id: item.id,
        price: item.price,
        name: item.name,
        subjects: item.subjects,
        syllabusNum: item.syllabusNum
      }
    })
    this.xesLog(
      'exposure',
      { key: 'coure-center-page-pv', type: 'xeslog-courseCenterList-exposure', content: list },
      { target: this.$refs.courseList }
    )
  },
  components: {
    ...courseCenterComponents
  },
  computed: {
    ...mapState({
      xAreaID: state => state.xAreaID,
      pagination: state => state.CourseCenter.pagination,
      userIsLogin: state => state.userIsLogin,
      courseList: state => state.CourseCenter.courseList,
      purchaseCount: state => state.CourseCenter.purchaseCount,
      courseCount: state => state.CourseCenter.courseCount,
      subjectName: state => state.subjectName,
      subjectNameZh: state => state.subjectNameZh,
      subjectEnum: state => state.subjectEnum,
      gradeEnum: state => state.gradeEnum,
      siftCourseType: state => state.CourseCenter.siftCourseType
    }),
    hasMore() {
      return this.page < this.pagination
    },
    currentGrade() {
      const userGrade = this.$store.state.cookies.userGrade
        ? this.$store.state.cookies.userGrade
        : 4
      const { grade = userGrade } = this.$route.params
      return Number(grade)
    },
    courseType() {
      return Number(this.$route.params.courseType)
    }
  },
  methods: {
    ...mapMutations({
      addList: types.ADD_COURSE_LIST
    }),
    changeListMode(mode, event) {
      this.mode = mode
      Cookies.set('xes_list_type', mode, {
        domain: '.xueersi.com'
      })
      const XESLog = new this.$XESLog({
        key: 'xeslog-changeListMode-courseCenter',
        clickid: '1.2.18',
        showmode: mode,
        clickurl: this.computedURL(this.$route.fullPath)
      })
      XESLog.push({ eventname: 'click', target: event.target }, this.$route)
    },
    async scrollLoad() {
      const innerHeight = Math.ceil(window.innerHeight)
      const scrollY = Math.ceil(window.scrollY)
      const scrollHeight = document.body.scrollHeight
      if (this.scrollLoading) return
      if (scrollHeight < scrollY + innerHeight + 50) {
        // 到达底部 加载更多
        this.scrollLoading = true
        this.getCourses()
      }
    },
    async getCourses() {
      if (!this.hasMore) {
        this.scrollLoading = false
        return
      }
      try {
        const { params, query } = this.$route
        const { courseType, grade, subject } = params
        const location = CourseLocation[courseType] || 5
        const page = this.page + 1
        // 课程标准化-获取课程列表
        const newQuery = {}
        for (let key in query) {
          if (query[key] && siftParams[key]) {
            newQuery[siftParams[key]] = query[key]
          }
        }
        const { data } = await Course.getCourses(
          { provinceId: this.$store.state.xAreaID || 100, courseType, location, grade },
          {
            rootState: this.$store.state,
            params: { ...newQuery, curpage: page, subjectId: subject }
          }
        )
        // const { data } = await Course.getCourses({type, grade, subject, page}, { params: query, rootState: this.$store.state })
        const courseList = data
        this.addList(courseList)
        const list = courseList.map(item => {
          return {
            category: item.category,
            id: item.id,
            price: item.price,
            name: item.name,
            subjects: item.subjects,
            syllabusNum: item.syllabusNum
          }
        })
        this.xesLog(
          'exposure',
          { type: 'xeslog-courseCenterList-exposure', content: list },
          { target: this.$refs.courseList }
        )
        this.page = page
        this.scrollLoading = false
      } catch (e) {
        this.scrollLoading = false
        if (this.page > 2) {
          this.page = this.page - 1
        }
      }
    },
    xesLog(eventName, params, event) {
      // const { subject = 'all', grade, courseType } = this.$route.params
      // const subjectNum = Number(subject)
      const XESLog = new this.$XESLog({
        // subjectid: subjectNum,
        // gradeid: Number(grade),
        // coursetype: Number(courseType),
        ...params
      })
      XESLog.push({ eventname: eventName, target: event.target }, this.$route)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/entry';
.course-center {
  min-width: 1200px;
}
.container {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 30px;
}
.breadcrumb {
  // padding: 15px 0;
  font-size: 12px;
  .breadcrumb__index {
    color: #999;
  }
  .breadcrumb__courseCenter {
    color: #333333;
    &::before {
      content: '>';
      padding: 0 10px;
    }
  }
}
@include b(list-tab) {
  height: 40px;
  line-height: 40px;
  border-bottom: 2px solid #DCAF80;
  font-size: 14px;
  margin-bottom: 20px;
  @include e(title) {
    background-color: #DCAF80;
    color: #fff;
    float: left;
    padding: 0 14px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }
  @include e(right-bar) {
    height: 40px;
    line-height: 40px;
    float: right;
    & > div {
      float: left;
    }
  }
}

@include b(right-bar) {
  font-size: 0;
  @include e(text) {
    font-size: 12px;
    padding: 0 12px;
    strong {
      color: #e74c3c;
      font-weight: normal;
    }
  }
  @include e(mode-btn) {
    display: none;
    width: 40px;
    height: 40px;
    text-align: center;
    color: #999999;
    cursor: pointer;
    i {
      font-size: 14px;
    }
    @include m(active) {
      color: #333;
      background: #e6e6e6;
    }
  }
}
.no-course {
  text-align: center;
  margin-top: 25px;
  p {
    margin-top: 20px;
    line-height: 35px;
    font-size: 16px;
  }
  .no-course__img {
    width: 200px;
    height: 200px;
  }
}
.courseList {
  margin-left: -4.5px;
  margin-right: -4.5px;
}
</style>



// WEBPACK FOOTER //
// ./src/views/CourseCenter/index.vue